export function formatMoney(money, locale = 'nl') {
    return new Intl.NumberFormat(locale, { style: 'currency', currency: 'EUR' }).format(money)
}
